<template>
  <slide-y-up-transition>
    <div v-if="state !== null">
      <div
        class="feedback-input position-absolute"
        v-if="getFirstError(errors, 'key')"
      >
        <span class="feedback-input__text">
          {{
            $lang.errors[getFirstError(errors, "key")]
              | replace(label, ...getFirstError(errors, "params"))
          }}
        </span>
      </div>
    </div>
  </slide-y-up-transition>
</template>
<script>
/* guidance: this component is wrapper for vuelidate errors of inputs */

import { startsWith, pathOr } from "ramda";

export default {
  props: {
    label: {
      // label for show in errors
      type: String,
      default: "",
    },
    vuelidateObj: {
      // vulidate object
      type: Object,
      default: null,
    },
    state: {
      // input state for validation
      type: Boolean,
      default: null,
    },
  },
  computed: {
    errors() {
      /* guidance: generate custom errors array with of vulidate object */

      const data = [];
      const paramsObj = this.vuelidateObj.$params; // get all of current params for

      for (const key of Object.keys(this.vuelidateObj)) {
        if (!startsWith("$", key)) {
          const value = this.vuelidateObj[key];
          let params = [];
          const paramsData = paramsObj[key];
          if (key === "between") {
            // get between params
            params = [paramsData.min, paramsData.max];
          }
          if (key === "minLength") {
            // get min minLength params
            params = [paramsData.min];
          }
          if (key === "maxLength") {
            // get min maxLength params
            params = [paramsData.max];
          }
          if (key === "numericLength") {
            // get min maxLength params
            params = [4];
          }
          // pushing last data generated
          data.push({ key, value, params });
        }
      }
      return data;
    },
  },
  methods: {
    startsWith,
    pathOr,
    getFirstError(errors, key) {
      const firstError = errors.find((item) => item.value === false);
      return pathOr(null, [key], firstError);
    },
  },
};
</script>
